import LockIcon from '@mui/icons-material/Lock';
import { ReactComponent as UnlockIcon } from 'images/unlockFilledPerson.svg';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuUserEntityPermissionsDialogButtonProps = Omit<
  ContextMenuButtonProps,
  'icon' | 'label' | 'onClick'
> & {
  onClick: NonNullable<ContextMenuButtonProps['onClick']>;
};

export const ContextMenuUserEntityPermissionsDialogButton: React.FC<
  ContextMenuUserEntityPermissionsDialogButtonProps
> = ({ onClick, ...restProps }) => {
  const translate = useTypedTranslate();

  const record = useRecordContext();
  const { onCloseMenu } = useContextMenuContext();
  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={
        record?.permissionsCount ? <UnlockIcon fontSize="small" /> : <LockIcon fontSize="small" />
      }
      label={
        record?.permissionsCount
          ? translate('app.merchantAccounts.accessEditing')
          : translate('app.merchantAccounts.accessEnable')
      }
      {...restProps}
      onClick={handleClick}
    />
  );
};
